export class PlayerLocomotionGravity {

    constructor() {
    }
}